/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagereset2Inputs */

const en_ticketpagereset2 = /** @type {(inputs: Ticketpagereset2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear filters`)
};

const de_ticketpagereset2 = /** @type {(inputs: Ticketpagereset2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter zurücksetzen`)
};

/**
* | output |
* | --- |
* | "Clear filters" |
*
* @param {Ticketpagereset2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagereset2 = /** @type {((inputs?: Ticketpagereset2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagereset2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagereset2(inputs)
	return de_ticketpagereset2(inputs)
});
export { ticketpagereset2 as "ticketPageReset" }